<section class="container">
  <section class="heading" data-testid="active-state-title">
    <app-dot-pulse />
    <p class="body bold">Engineer visit</p>
  </section>

  @if (vm.isToday) {
    <section>
      <p class="body" data-testid="engineer-visit-message">They’ll arrive today</p>
    </section>
  } @else {
    <section>
      <p class="body" data-testid="engineer-visit-message">
        @if (vm.startTime && vm.endTime) {
          They’ll arrive on {{ vm.appointmentDate | date: 'EEEE d MMMM yyyy' }} at {{ vm.startTime | timeFormat }}-{{
            vm.endTime | timeFormat
          }}.
        } @else {
          They’ll arrive on {{ vm.appointmentDate | date: 'EEEE d MMMM yyyy' }}.
        }
      </p>
    </section>
  }
</section>
